import {FIREBASE_AUTH} from '@/enums/web-error.enum'

export class FirebaseAuthError extends Error {
  constructor ({message, firebaseErrorCode}) {
    super(message)
    this.code = FIREBASE_AUTH
    this.firebaseErrorCode = firebaseErrorCode
  }
}
